import * as React from 'react';
import { twMerge } from 'tailwind-merge';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  ticks?: boolean;
  ticksPrimary?: boolean;
  priority?: boolean;
  padding?: number | string;
}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  (
    {
      ticks = false,
      ticksPrimary = false,
      priority = false,
      padding = 16,
      children,
      className,
      onClick,
      style,
      ...rest
    },
    ref,
  ) => {
    const padStyle = typeof padding === 'number' ? `${padding}px` : padding;

    return (
      <div
        ref={ref}
        onClick={onClick}
        className={twMerge(
          'bg-surface-1 border-stroke-1 relative border',
          priority && 'border-l-primary-9 border-l-2',
          ticks && 'ticks',
          ticks && ticksPrimary && 'ticks-primary',
          onClick && 'cursor-pointer',
          className,
        )}
        style={{ padding: padStyle, ...style }}
        {...rest}
      >
        {children}
      </div>
    );
  },
);
Card.displayName = 'Card';
